import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Button, Row, Col, Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone, solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import BlockUi from 'react-block-ui';
import SignalRService from "src/controllers/SignalRService";
import Toastr from '../utils/toastr';

class ContactConfirmDelete extends Component {

    constructor(props) {

        super(props)
        this.state = {
            loading: false
        };

        this.setLoading = this.setLoading.bind(this);
        this.deleteContact = this.deleteContact.bind(this);
        this.deletionResult = this.deletionResult.bind(this);
        this.toastrRef = React.createRef();
    }

    componentDidMount() {
        SignalRService.registerContactResult(this.deletionResult);
    }

    setLoading(value) {
        this.setState({
            loading: value
        });
    }

    deleteContact() {

        this.setLoading(true);

        let data = {
            "extension": this.props.extension,
            "userId": this.props.userId,
            "contactId": this.props.contactId
        };

        SignalRService.deleteContact(data, e => { });

    }

    deletionResult(message) {

        this.setLoading(false);
        this.props.reload();
        this.props.toggleModal();      
        let data = JSON.parse(message);
        if (!data.Ok) {
            this.toastrRef.current.setType("error");
            this.toastrRef.current.setMessage(this.props.t("error"));
            this.toastrRef.current.show();
        }
    }

    render() {
        return (<>
            <Modal show={this.props.show} onHide={this.props.toggleModal} size="md" backdrop="static">
                <BlockUi tag="div" blocking={this.state.loading} color="#009ef7" message={this.props.t("pleasewait")}>
                    <Modal.Header>
                        <Modal.Title><FontAwesomeIcon icon={duotone("warning")} /> {this.props.t("warning")}</Modal.Title>
                        <OverlayTrigger
                            placement="left"
                            delay={{ show: 250, hide: 400 }}
                            overlay={<Tooltip style={{ position: "fixed" }}>
                                {this.props.t("close")}
                            </Tooltip>}>
                            <Button onClick={this.props.toggleModal} className='float-end'><FontAwesomeIcon icon={solid('xmark')} /></Button>
                        </OverlayTrigger>
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            <Col>
                                <p>{this.props.t("youareabouttodeletecontact")} {this.props.group}</p>

                                <p>{this.props.t("areyousure")}</p>
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={this.deleteContact}>
                            <FontAwesomeIcon icon={duotone("paper-plane-top")} /> {this.props.t("ok")}
                        </Button>
                    </Modal.Footer>
                </BlockUi>
            </Modal>
            <Toastr ref={this.toastrRef} />
        </>
        )
    }
    
}

const mapStateToProps = (state) => {
    return {
        extension: state.agent.extension,
        userId: state.agent.userId
    };
};

export default compose(connect(mapStateToProps, {}), withTranslation())(ContactConfirmDelete);